import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const OrderDateCellContent: React.FC<OrderDateCellContent.Props> = ({
	item,
}) => {
	const { dateFns } = useAppContext();

	const { content, backgroundColor, textColor } = useMemo(
		() => cellProcessing(item, dateFns),
		[item, dateFns],
	);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			textColor={textColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace OrderDateCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default OrderDateCellContent;
